/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FunnelConversationExportCustomColumn } from './FunnelConversationExportCustomColumn';
import type { SearcherDocumentSearchFilter } from './SearcherDocumentSearchFilter';
import type { SearcherDocumentSearchSort } from './SearcherDocumentSearchSort';
/**
 * Request body for async export of conversations table search results.
 */
export type FunnelConversationSearchExportBodyParams = {
    /**
     * Free text search term
     */
    search?: string;
    /**
     * Advanced filters currently applied in the table
     */
    filters?: Array<SearcherDocumentSearchFilter>;
    /**
     * Sort descriptors currently applied in the table
     */
    sort?: Array<SearcherDocumentSearchSort>;
    /**
     * Funnel identifier currently being viewed
     */
    funnelId: number;
    /**
     * Browser timezone used for date formatting in the spreadsheet
     */
    timezone?: string;
    /**
     * Ordered custom columns currently rendered in the table
     */
    customColumns?: Array<FunnelConversationExportCustomColumn>;
    /**
     * Export output format
     */
    format?: FunnelConversationSearchExportBodyParams.format;
};
export namespace FunnelConversationSearchExportBodyParams {
    /**
     * Export output format
     */
    export enum format {
        XLSX = 'xlsx',
        CSV = 'csv',
    }
}

